<template>
  <span :title="bankLabel">{{ displayName }}</span>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {bankList} from "@/http/basicDetails";
import {SysBanksInfo} from "@/domain/sys";

let cachedBanks: SysBanksInfo[] | null = null
let bankListRequest: Promise<SysBanksInfo[]> | null = null

function loadBanks(): Promise<SysBanksInfo[]> {
  if (cachedBanks) {
    return Promise.resolve(cachedBanks)
  }

  if (!bankListRequest) {
    bankListRequest = bankList({unPage: true} as any)
        .then((banks: SysBanksInfo[]) => {
          cachedBanks = banks
          return banks
        })
        .finally(() => {
          bankListRequest = null
        })
  }

  return bankListRequest
}

@Options({
  props: {
    bankId: {
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      banks: cachedBanks || []
    }
  },
  computed: {
    bank() {
      return this.banks.find((item: SysBanksInfo) => String(item.id) === String(this.bankId))
    },
    displayName() {
      if (this.bank) {
        return this.bank.fullName || this.bank.shortName
      }

      return this.bankId || '-'
    },
    bankLabel() {
      if (!this.bank) {
        return String(this.displayName)
      }

      return [this.bank.shortName, this.bank.fullName].filter(Boolean).join(' - ')
    }
  },
  created() {
    loadBanks().then((banks: SysBanksInfo[]) => {
      this.banks = banks
    })
  }
})
export default class BankName extends Vue {
}
</script>
